import {
  AdultFemale,
  AdultMale,
  ChildFemale,
  ChildMale,
  CommonProfile,
  SeniorFemale,
  SeniorMale,
} from '@shared/assets';

export const getDefaultProfilePicDisplay = (gender: null | string | undefined, age: null | number | undefined) => {
  if (!gender) {
    return CommonProfile;
  }

  if (!age && age !== 0) {
    return CommonProfile;
  }

  if (gender === 'M') {
    if (age < 18) {
      return ChildMale;
    }
    if (age > 60) {
      return SeniorMale;
    }
    return AdultMale;
  }
  if (age < 18) {
    return ChildFemale;
  }
  if (age > 60) {
    return SeniorFemale;
  }
  return AdultFemale;
};
